import type { FilterDefinition } from '@atlassian/mpac-primitives';

export const filterDefinitions: FilterDefinition[] = [
  {
    filterId: 'product',
    label: 'Product',
    isMulti: false,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: false,
  },
  {
    filterId: 'trustSignals',
    label: 'Trust signals',
    isMulti: true,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: true,
  },
  {
    filterId: 'categories',
    label: 'Categories',
    isMulti: false,
    isSearchable: true,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: false,
  },
  {
    filterId: 'useCases',
    label: 'Use Cases',
    isMulti: true,
    isSearchable: false,
    hiddenByDefault: false,
    hasClearSelectionButton: true,
    groupSelectedItems: true,
  },
];
